// app/javascript/components/searchable_select.js
import $ from 'jquery';
import 'select2';
import { select2Matcher } from '../utils/text_match';

// Initialize a single select element
const initSingleSearchableSelect = ($select) => {
  // Avoid re-initializing if already initialized
  if ($select.hasClass('select2-hidden-accessible')) {
    return;
  }

  // Get custom options from data attributes
  const placeholder = $select.data('placeholder') || 'Rechercher...';
  const allowClear = $select.data('allow-clear') !== false;
  const minInputLength = $select.data('min-input') || 0;
  const noResultsText = $select.data('no-results') || 'Aucun résultat trouvé';
  const dropdownParent = $select.data('dropdown-parent');

  // Configure Select2 options
  const options = {
    placeholder: placeholder,
    allowClear: allowClear,
    minimumInputLength: minInputLength,
    width: '100%',
    language: {
      noResults: function() {
        return noResultsText;
      },
      searching: function() {
        return 'Recherche...';
      },
      inputTooShort: function(args) {
        const remaining = args.minimum - args.input.length;
        return `Veuillez entrer ${remaining} caractère(s) ou plus`;
      }
    },
    // Recherche par mots : insensible à la casse, aux accents et à l'ordre,
    // pour que « Olivia Bironneau » retrouve « BIRONNEAU Olivia ».
    matcher: select2Matcher
  };

  // Set dropdown parent - attach to body for better z-index handling
  // The CSS handles z-index: 99999 for .select2-container--open
  if (dropdownParent && dropdownParent !== 'body') {
    options.dropdownParent = $(dropdownParent);
  }
  // Don't set dropdownParent for modals - let it attach to body with high z-index

  // Initialize Select2
  $select.select2(options);

  // Add custom class to the Select2 container for styling
  $select.on('select2:open', function() {
    const searchField = document.querySelector('.select2-container--open .select2-search__field');
    if (searchField) {
      searchField.focus();
      searchField.setAttribute('placeholder', 'Tapez pour rechercher...');
    }
  });
};

const initSearchableSelect = () => {
  $('.searchable-select').each(function() {
    initSingleSearchableSelect($(this));
  });

  // Watch for modals opening to reinitialize selects inside them
  setupModalObserver();
};

// Observe modal visibility changes and reinitialize selects when modals open
const setupModalObserver = () => {
  // Observe class changes on hex_modal2 elements
  const modals = document.querySelectorAll('.hex_modal2');

  modals.forEach(modal => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          const hasActiveClass = modal.classList.contains('hex_modal_active');
          if (hasActiveClass) {
            // Modal just opened, reinitialize searchable selects inside
            setTimeout(() => {
              $(modal).find('.searchable-select').each(function() {
                const $select = $(this);
                // Destroy and reinitialize to ensure proper display
                if ($select.hasClass('select2-hidden-accessible')) {
                  $select.select2('destroy');
                }
                initSingleSearchableSelect($select);
              });
            }, 100);
          }
        }
      });
    });

    observer.observe(modal, { attributes: true });
  });

  // Also watch for dynamically shown elements (like #add-contact-form)
  const dynamicContainers = document.querySelectorAll('#add-contact-form, #filter-panel');
  dynamicContainers.forEach(container => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'style') {
          const isVisible = container.style.display !== 'none';
          if (isVisible) {
            setTimeout(() => {
              $(container).find('.searchable-select').each(function() {
                const $select = $(this);
                if (!$select.hasClass('select2-hidden-accessible')) {
                  initSingleSearchableSelect($select);
                }
              });
            }, 100);
          }
        }
      });
    });

    observer.observe(container, { attributes: true });
  });
};

// Destroy and reinitialize (useful for Turbo/dynamic content)
const destroySearchableSelect = () => {
  $('.searchable-select').each(function() {
    const $select = $(this);
    if ($select.hasClass('select2-hidden-accessible')) {
      $select.select2('destroy');
    }
  });
};

export { initSearchableSelect, destroySearchableSelect };
